import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/documento';

const filesEndpoints = {
    //file
    //filename
    //id
    uploadFile: (payload, context = EXTERNAL_CONTEXT) => stipAxios.post(`${context}${BASE_ENDPOINT}/upload`, payload),
    uploadGuestFile: (payload) => stipAxios.post(`/guest/upload`, payload),
    //deleteFile: idFile => stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/delete/${idFile}`),
    getFileData: (idFile) => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/${idFile}`),
    getFileBlob: (idFile) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/download/${idFile}`, {
            responseType: 'arraybuffer',
        }),
};

export default filesEndpoints;
